module.exports = __webpack_public_path__ + "static/media/war-truck-large.66549f50.jpg";